import React, {forwardRef, useEffect, useImperativeHandle, useRef, useState} from "react";
import {IconClose} from "../../Icon";
import {t} from "i18next";
import {Modal, message} from "antd";
import {getGroupList, getTagCount, getTagList, tagsByGroupId, updateTag} from "../../../model/tag";
import {
    generateUUID2,
    getImagePathWithTheme,
    isInPageLibrary,
    isInPageProperties,
    isInPageTag, isInPageTagList,
    isStringNullOrEmpty
} from "../../utils";
import {updateCard} from "../../../model/card";
import DialogMessageBox from "../../common/DialogMessageBox";
import {updateNote} from "../../../model/note";
import {noteServer} from "../../common/notesServer";
import {KEYS} from "../../../@excalidraw/packages/excalidraw/keys";
import {dbGetHighlight, updateHighlight} from "../../../model/highlight";
import global from "../../global";
import {EVENT_REFRESH_TAG_LSIT, MAX_Z_INDEX} from "../../Const";
import {postMessage} from "@/common/event";
import {debugLog} from "@/LogUtils";
import {updateBoard} from "@model/board";

let mArrayTags:any = [];
let mArrayAllTags:any = [];
let mArraySelectItems:any;
let mIsTagChange:boolean = false;
let mLastEnter:any;
const DialogTagManager = forwardRef((props:{from:string|'library'|'project',onDismissCallback:any}, ref)=>{
    useImperativeHandle(ref,()=>({
        onShowDialog:onShowDialog
    }));
    const [isShowDialog,setIsShowDialog] = useState(false);
    const [arrayTags,setArrayTags] = useState([]);
    const [arraySelectTags,setArraySelectTags] = useState([]);
    const [inputTag,setInputTag] = useState('');
    const [arrayGroups,setArrayGroups] = useState([]);
    const [isHoverGroup,setIsHoverGroup] = useState(false);
    const mSelectGroupRef = useRef({id:'all'});

    const inputTagRef = useRef(null);
    const mArrayAllDbTags = useRef(null);
    const mCallback = useRef<any>(null);

    function onKeyDownEvent(event:any){
        // debugLog('keydown',event);
        if (!isShowDialog)return;
        if (event.key == KEYS.ARROW_DOWN){
            var nIndex = arrayTags.findIndex(p=>p.isChecked);
            nIndex ++;
            if (nIndex >= arrayTags.length){
                nIndex = 0;
            }

            var arrayNew = [...arrayTags];
            arrayNew.forEach(p=>p.isChecked = false);
            arrayNew[nIndex].isChecked = true;
            setArrayTags(arrayNew);
            scrollTagToIndex(nIndex);
        }else if (event.key == KEYS.ARROW_UP){
            var nIndex = arrayTags.findIndex(p=>p.isChecked);
            if (nIndex == 0){
                nIndex = arrayTags.length;
            }
            nIndex --;
            var arrayNew = [...arrayTags];
            arrayNew.forEach(p=>p.isChecked = false);
            arrayNew[nIndex].isChecked = true;
            setArrayTags(arrayNew);
            scrollTagToIndex(nIndex);
        }
        else if (event.key == KEYS.ENTER){
            //当前选中的一个
            const arrayFilters = arrayTags.filter(p=>p.isChecked);
            if (arrayFilters && arrayFilters.length > 0){
                onClickTag(arrayFilters[0]);
            }
        }
    }

    useEffect(()=>{
        document.body.addEventListener('keydown',onKeyDownEvent);

        return ()=>{
            document.body.removeEventListener('keydown',onKeyDownEvent);
        }
    })

    useEffect(() => {
        return ()=>{
            mArrayAllTags = [];
            mArrayTags = [];
        }
    }, []);

    const onShowDialog = (arraySelectItems:any,callback:any)=>{
        mIsTagChange = false;
        mArraySelectItems = arraySelectItems;
        setIsShowDialog(true);
        setInputTag('');
        mCallback.current = callback;

        arraySelectItems.forEach(p=>{
            if (!p.tags){
                p.tags = [];
            }
        })

        //搞上tag的id
        var arrayNewTags:any = [];
        if (arraySelectItems){
            const arrayStringTags = getSelectedItemTags(arraySelectItems);
            arrayStringTags.forEach(p=>{
                arrayNewTags.push({
                    name:p
                })
            })
            arrayNewTags = arrayNewTags.reverse();
            setArraySelectTags(arrayNewTags);
        }else{
            setArraySelectTags([]);
        }
        refreshGroupList();
        refreshTagList(arrayNewTags);
    }

    /**
     * 滚动到索引
     * @param nIndex
     */
    const scrollTagToIndex = (nIndex:number)=>{
        const div = document.getElementById('div-dialog-tag-mgr-list');
        if (nIndex > 8){
            div.scrollTo(0,(nIndex-8)*32)
        }else{
            div.scrollTo(0,0)
        }
    }

    /**
     * 刷新标签列表
     */
    const refreshTagList = (arraySelectedTag:any)=>{
        if (mSelectGroupRef.current?.id === 'all' || mSelectGroupRef.current == null){
            getTagList().then(res=>{
                sortTag(res);

                mArrayAllTags = [...res];
                mArrayAllDbTags.current = res;
                //res中移除已有的
                for (let i=0;i<mArrayAllTags.length;i++){
                    if (arraySelectedTag.some(p=>p.name == mArrayAllTags[i].name)){
                        //remove...
                        const nIndex = res.indexOf(mArrayAllTags[i]);
                        res.splice(nIndex,1);
                    }
                }
                mArrayTags= res//.slice(0,15);
                if (mArrayTags.length > 0) {
                    mArrayTags.forEach(p=>p.isChecked = false);
                    if (mArrayTags.length > 0) {
                        mArrayTags[0].isChecked = true;
                    }
                }
                setArrayTags(mArrayTags);
            })
        }else{
            refreshTagListByGroupId(mSelectGroupRef.current.id,arraySelectedTag)
        }
    }

    /**
     * 标签排序
     * @param arrayTags
     */
    const sortTag = (arrayTags:any)=>{
        arrayTags.sort((a,b)=>{
            if (a.updateTime && b.updateTime){
                return b.updateTime - a.updateTime;
            }
            return 0;
        })
        // arrayTags.sort((a,b)=>{
        //     if (a.tagSort != undefined && b.tagSort != undefined){
        //         return a.tagSort - b.tagSort;
        //     }
        //     return 0;
        // })
    }

    const refreshTagListByGroupId = (groupId:any,arraySelectedTag:any)=>{
        tagsByGroupId(groupId).then(res=>{
            sortTag(res);

            mArrayAllTags = [...res];
            //res中移除已有的
            for (let i=0;i<mArrayAllTags.length;i++){
                if (arraySelectedTag.some(p=>p.name == mArrayAllTags[i].name)){
                    //remove...
                    const nIndex = res.indexOf(mArrayAllTags[i]);
                    res.splice(nIndex,1);
                }
            }
            mArrayTags= res//.slice(0,15);
            if (mArrayTags.length > 0) {
                mArrayTags.forEach(p=>p.isChecked = false);
                if (mArrayTags.length > 0) {
                    mArrayTags[0].isChecked = true;
                }
            }
            setArrayTags(mArrayTags);
        })
    }

    const refreshGroupList = ()=>{
        getGroupList().then(async (res)=>{
            const nTagCount = await getTagCount();
            if (res.length > 0 || nTagCount > 0){
                const arrayTmp:any = [];
                arrayTmp.push({
                    id:'all',
                    value:'all',
                    isChecked:true,
                    name:t("All")
                })
                arrayTmp.push({
                    id:'-1',
                    value:'-1',
                    name:t("Ungrouped")
                })
                arrayTmp.push(...res);
                setArrayGroups(arrayTmp);
            }
        })
    }

    /**
     * 取选中的元素的标签
     */
    const getSelectedItemTags = (arraySelectItems:any)=>{
        const arraySelected = arraySelectItems;
        let arrayIntersection:any = [];
        if (arraySelected.length > 0){
            arrayIntersection = arraySelected[0].tags??[];
            for (let i=1;i<arraySelected.length;i++){
                if (arraySelected[i].tags){
                    arrayIntersection = arraySelected[i].tags.filter(p=>arrayIntersection.includes(p));
                }else{
                    return [];
                }
            }
        }

        return arrayIntersection;
    }

    /**
     * 更新所有标签
     * @param arrayNewTags
     */
    const updateItemTags = async (arrayNewTags:any,itemRemoved:any)=>{
        let arrayNewStringTags:any = [];
        //标签只保存文本....
        arrayNewTags.forEach(p=>{
            arrayNewStringTags.push(p.name);
        })
        for (let i=0;i<mArraySelectItems.length;i++){
            const p = mArraySelectItems[i];
            if (p.tags){
                //remove 一个条目....
                if (itemRemoved){
                    const nIndex = p.tags.indexOf(itemRemoved.name);
                    if (nIndex >= 0){
                        p.tags.splice(nIndex,1);
                    }
                }

                for (let i=0;i<arrayNewStringTags.length;i++){
                    if (!p.tags.includes(arrayNewTags[i].name)){
                        p.tags.push(arrayNewTags[i].name);
                    }
                }
            }else{
                p.tags = arrayNewStringTags;
            }
            if (props.from == 'library'){
                if (p.type && p.type != 'project'){
                    if (p.type == 'board'){
                        //更新到board表
                        await updateBoard(p)
                    }else{
                        //各种混合吧。。这里tags 标签管理可能包含有project..
                        await updateCard(p,false);
                        //更新highlight中的标签
                        const dbHighlight = await dbGetHighlight(p.id);
                        if (dbHighlight){
                            dbHighlight.tags = p.tags;
                            await updateHighlight(dbHighlight);
                        }
                    }
                }
                else{
                    //更新project....
                    await updateNote(p);
                }
            }else{
                //更新project....
                if (p.type == 'board'){
                    //更新board--也要更新当前画板上的..
                    await updateBoard(p);
                }else{
                    await updateNote(p);
                }
            }

            if (window.onUpdateTag){
                window.onUpdateTag(p);
            }
        }

        if (mCallback.current){
            mCallback.current(arrayNewTags,itemRemoved)
        }
    }

    /**
     * 标签点击
     * @param p
     */
    const onClickTag = async (p)=>{
        if (p.showName) {
            //判断下名称，有可能在别的group已存在了。
            const arrayFilters = mArrayAllDbTags.current?.filter(pp=>pp.name.toLowerCase() == p.name?.toLowerCase());
            let bExist = arrayFilters.length > 0;
            if (bExist){
                message.info(t("Tag exist"));
                return;
            }

            //添加一个新的标签，并添加到选择
            delete p.showName;
            p.createTime = Date.now();
            p.updateTime = Date.now();
            if (mSelectGroupRef.current && mSelectGroupRef.current?.id != 'all' && mSelectGroupRef.current?.id != -1){
                p.groupId = mSelectGroupRef.current.id;
            }

            await updateTag(p);
            postMessage(EVENT_REFRESH_TAG_LSIT);

            //添加到列表...
            mArrayTags.splice(0, 0, p);
            mArrayTags.forEach(p=>p.isChecked = false);
            mArrayTags[0].isChecked = true;
            setArrayTags(mArrayTags);

            if (mArraySelectItems) {
                var arrayNewSelect:any = [p];
                arrayNewSelect.push(...arraySelectTags);
                setArraySelectTags(arrayNewSelect);

                //更新标签
                await updateItemTags(arrayNewSelect, null);

                //刷新列表--
                refreshTagList(arrayNewSelect);
            }
        } else {
            //没有选中的项目...
            if (!mArraySelectItems) return;
            //添加到待选择列表
            var arrayNewSelect:any = [...arraySelectTags];
            const nIndex = arraySelectTags.findIndex((value, index, obj) => {
                return (value.name == p.name)
            })
            if (nIndex >= 0) {
                arrayNewSelect.splice(nIndex, 1);
            }
            arrayNewSelect.splice(0, 0, p);
            setArraySelectTags(arrayNewSelect);

            p.updateTime = Date.now();
            await updateTag(p);
            //更新标签
            await updateItemTags(arrayNewSelect, null);

            //刷新列表--
            refreshTagList(arrayNewSelect);
        }

        // var arrayNew:any = [...mArrayTags];
        // arrayNew.forEach(p=>p.isChecked = false);
        // arrayNew[0].isChecked = true;
        // setArrayTags(arrayNew);

        setInputTag('');
        inputTagRef.current?.focus();
        mIsTagChange = true;
        window.globalRefreshList();
    }

    return(
        <Modal zIndex={MAX_Z_INDEX} width={518} afterClose={()=>{
            props.onDismissCallback(mIsTagChange,mArraySelectItems);
        }} afterOpenChange={(e)=>{
            inputTagRef.current?.focus();
            global.g_showDialogs.dialogTagManager = e;
        }} open={isShowDialog} centered={true} closable={true} closeIcon={<IconClose/>} footer={''} onCancel={()=> {
            setIsShowDialog(false);
            mSelectGroupRef.current = null;
        }}>
            <div style={{marginBottom:'-16px'}}>
                <span className={'dialog-title'}
                      style={{width: '100%', textAlign: 'center', display: 'block'}}>{t("Manage tags")}</span>
                <div className={'line mt-12'} style={{margin: '12px -22px'}}></div>

                <input ref={inputTagRef} className={'input-border default-font-size'} placeholder={t('Add tag')}
                       style={{width: '100%', paddingLeft: '16px'}} value={inputTag} onChange={(e) => {
                    const szValue = e.currentTarget.value;
                    setInputTag(szValue);
                    if (isStringNullOrEmpty(szValue)) {
                        if (mArrayTags.length > 0) {
                            mArrayTags.forEach(p=>p.isChecked = false);
                            if (mArrayTags.length > 0) {
                                mArrayTags[0].isChecked = true;
                            }
                        }
                        setArrayTags(mArrayTags);
                    } else {
                        const szIgnoreCase = szValue.toLowerCase();
                        let arrayFilter = mArrayAllTags.filter(p => p.name.toLowerCase().indexOf(szIgnoreCase) != -1);
                        const isExist = arrayFilter.some(p => p.name == szValue);
                        if (!isExist) {
                            arrayFilter.splice(0, 0, {
                                name: szValue,
                                showName: t('Create tag') + ' "' + szValue + '"',
                            })
                        }
                        arrayFilter.forEach(p=>p.isChecked = false);
                        if (arrayFilter.length > 0) {
                            arrayFilter[0].isChecked = true;
                        }
                        setArrayTags(arrayFilter);
                    }
                }}/>
                {/*tag*/}
                <div className={'dialog-border-shadow item-border'} style={{borderRadius: '8px',marginTop:'12px',border:'1px solid var(--box-shadow-border)'}}>
                    {
                        arraySelectTags.length != 0 &&
                        <div className={'tagContainer'} style={{
                            marginTop: '6px',
                            display: 'flex',
                            flexWrap: "wrap",
                            padding: '0 12px 12px 12px',
                            borderBottom: '1px solid var(--line-color)'
                        }}>
                            {
                                arraySelectTags.map(p => <div className={'flex-center tag mr-12 mt-6'}
                                                              style={{borderRadius: '100px'}}>
                                    <span># {p.name}</span>
                                    <div style={{
                                        height: '12px',
                                        width: '1px',
                                        background: 'var(--line-color)',
                                        marginLeft: '12px'
                                    }}></div>
                                    {/*//删除tag*/}
                                    <img style={{marginLeft: '12px'}} onClick={async () => {
                                        //remove....
                                        var arrayNewSelect = [...arraySelectTags];
                                        const nIndex = arrayNewSelect.indexOf(p);
                                        arrayNewSelect.splice(nIndex, 1);
                                        setArraySelectTags(arrayNewSelect);

                                        await updateItemTags(arrayNewSelect, p);
                                        mIsTagChange = true;

                                        //刷新...
                                        refreshTagList(arrayNewSelect);
                                    }}
                                         className={'img-8 cursor-pointer'} src={getImagePathWithTheme('close_black')}/>
                                </div>)
                            }
                        </div>
                    }

                    {
                        arrayGroups.length > 0 &&
                        <div className={`flex-row-vertical-center ${isHoverGroup ? '' : 'transparent-scrollbar'}`}
                             style={{
                                 overflow: `visible hidden`,
                                 padding: '13px 13px 10px 13px',
                                 borderBottom: '1px solid var(--line-color)',
                                 gap: '12px'
                             }} onMouseEnter={(e) => {
                            setIsHoverGroup(true);
                        }} onMouseLeave={(e) => {
                            setIsHoverGroup(false);
                        }}>
                            {
                                // group列表
                                arrayGroups.map((p, index) => {
                                    return (
                                        <div key={p.id} onClick={() => {
                                            var arrayNew = [...arrayGroups];
                                            arrayNew.forEach(p => p.isChecked = false);
                                            p.isChecked = true;
                                            setArrayGroups(arrayNew);
                                            mSelectGroupRef.current = p;
                                            //刷新tag
                                            refreshTagList(arraySelectTags);
                                        }} className={'tag cursor-pointer'} style={{
                                            padding: '3px 10px',
                                            borderRadius: '8px',
                                            background: p.isChecked ? '#3670F7' : 'transparent'
                                        }}>
                                    <span className={'span-single-line'} style={{
                                        width: '100%',
                                        height: '100%',
                                        display: 'block',
                                        color: p.isChecked ? '#FFFFFF' : 'var(--text-color)',
                                    }}>{p.name}</span>
                                        </div>
                                    )
                                })
                            }
                        </div>

                    }


                    {/*tag列表*/}
                    <div id={'div-dialog-tag-mgr-list'} style={{
                        width: '100%',
                        height: '300px', marginTop: '6px', overflowX: "hidden", overflowY: 'auto'
                    }}>
                        {
                            arrayTags.map((p, index) => <div key={p.id} onClick={() => {
                                onClickTag(p)
                            }} onMouseEnter={() => {
                                var arrayNew = [...arrayTags];
                                arrayNew.forEach(p => p.isChecked = false);
                                p.isChecked = true;
                                setArrayTags(arrayNew);
                                mLastEnter = p;
                            }} onMouseLeave={() => {
                                var arrayNew = [...arrayTags];
                                arrayNew.forEach(p => p.isChecked = false);
                                if (mLastEnter) {
                                    mLastEnter.isChecked = true;
                                }
                                setArrayTags(arrayNew);
                            }} className={'dropdown-item'} style={{padding: '0 0px'}}>
                                <span className={'span-single-line'} style={{
                                    width: '100%',
                                    height: '100%',
                                    display: 'block',
                                    color: p.isChecked ? '#FFFFFF' : '',
                                    background: p.isChecked ? '#3670F7' : 'transparent',
                                    padding: '0 12px',
                                    borderRadius: '2px'
                                }}># {p.showName ?? p.name}</span>
                            </div>)
                        }
                    </div>
                </div>


                {/*<div className={'flex-center'} style={{marginTop: '20px'}}>*/}
                {/*    <div className={'button-border-gray-style flex-center'} style={{minWidth: '164px', height: '38px'}}*/}
                {/*         onClick={() => {*/}
                {/*             setIsShowDialog(false);*/}
                {/*         }}>*/}
                {/*        <span>{t("Cancel")}</span>*/}
                {/*    </div>*/}
                {/*    <div className='flex-center button-solid-style ml-10'*/}
                {/*         style={{minWidth: '164px', height: '38px', alignSelf: 'center'}}*/}
                {/*         onClick={() => {*/}
                {/*             setIsShowDialog(false);*/}

                {/*             mArraySelectItems.forEach(p=>{*/}
                {/*                 //暂定不更新时间*/}
                {/*                 if (props.from == 'library'){*/}
                {/*                     updateCard(p,false);*/}
                {/*                 }else{*/}
                {/*                     //更新project....*/}
                {/*                     updateNote(p);*/}
                {/*                 }*/}
                {/*             })*/}
                {/*         }}>*/}
                {/*        <span className='ml-6 font-family-medium'>{t("Confirm")}</span>*/}
                {/*    </div>*/}
                {/*</div>*/}

            </div>
        </Modal>
    )
})
export default DialogTagManager;